import {
  IDispositivoActualizarFechaDevolucion,
  IFilterDispositivosAsignados,
  IFilterReporteDispositivoAsignado,
} from "../../Interfaces/DispositivoAsignado/IDispositivoAsignado";
import { fetchDispositivo } from "../http-common";

const PostActualizarFechaDevolucion = (
  data: IDispositivoActualizarFechaDevolucion
) => {
  return fetchDispositivo.post(
    `DispositivoAsignado/ActualizarFechaDevolucion`,
    data
  );
};
const allDispositivosAsignados = (
  filter: IFilterDispositivosAsignados,
  controller = new AbortController()
) => {
  return fetchDispositivo.post(`DispositivoAsignado/ListarAsignados`, filter, {
    signal: controller.signal,
  });
};

const postReporteDispositivoAsignado = (
  filter: IFilterReporteDispositivoAsignado
) => {
  return fetchDispositivo.post(
    `DispositivoAsignado/ReporteTabletsAsignadas`,
    filter,
    {
      responseType: "blob",
    }
  );
};

const postReporteDispositivoHistorico = (filter: any) => {
  return fetchDispositivo.post(
    `DispositivoAsignado/ReporteTabletHistorico`,
    filter,
    { responseType: "blob" }
  );
};
const dispositivoAsignadoService = {
  PostActualizarFechaDevolucion,
  allDispositivosAsignados,
  postReporteDispositivoAsignado,
  postReporteDispositivoHistorico,
};

export default dispositivoAsignadoService;
